import Notificacoes from './componentes/Notificacao.vue';

export default {
  path: '/notificacoes',
  component: Notificacoes,
  meta: { auth: true },
  name: 'notificacoes',
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/notificacoes/rotas.js